import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
var _ref = {
  name: "fxumzl",
  styles: "padding:0 10px;"
};
var _ref2 = {
  name: "45ra3g",
  styles: "overflow:hidden;max-height:700px;"
};
export var row = function row() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    isAd = _ref5.isAd,
    isFluid = _ref5.isFluid;
  return /*#__PURE__*/css("margin-bottom:30px;", isAd && _ref, " ", isFluid && _ref2);
};
export var btrInfo = {
  name: "d7ttjg",
  styles: "padding-top:30px;margin-bottom:30px;"
};
var _ref3 = {
  name: "542elh",
  styles: "padding-top:10px;"
};
export var searchContent = function searchContent() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    hasSingleFeaturedProperty = _ref6.hasSingleFeaturedProperty,
    hasNoResult = _ref6.hasNoResult;
  return /*#__PURE__*/css("max-width:1020px;margin-left:auto;margin-right:auto;", hasSingleFeaturedProperty && _ref3, " ", hasNoResult && /*#__PURE__*/css("padding-left:0;padding-right:0;", media('>=tablet'), "{max-width:none;}"));
};
var _ref4 = {
  name: "h5fkc8",
  styles: "margin-top:32px;"
};
export var items = function items() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    hasSingleFeaturedProperty = _ref7.hasSingleFeaturedProperty;
  return /*#__PURE__*/css(hasSingleFeaturedProperty && _ref4, " ", media('>=tablet'), "{margin-top:0;}");
};
export var item = /*#__PURE__*/css("margin:0 auto;background-color:", colors.neutral.surface.default, ";", media('>=tablet', '<desktop'), "{max-width:722px;}");